module.exports = __webpack_public_path__ + "static/3-Tri-01-c1a8dc6ad528ee9d954eb9dff9b14b10.png";